import { render, staticRenderFns } from "./StudentsUpload.vue?vue&type=template&id=bdf0c82c"
import script from "./StudentsUpload.vue?vue&type=script&lang=js"
export * from "./StudentsUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports